import PropTypes from 'prop-types'
import { shareTelegram, shareTwitter, shareWhatsApp } from './GRShareButtons'
import { getShareMessage } from '../GameRoom/gameRoomUtils'
import { getGameRoomTimeDetails } from '../utils/getGameRoomTimeDetails'
import useOutsideClick from '../hooks/useOutsideClick'
import '../GameRoom/GRStyle.css'

const ShareActionDropdown = ({
  grDetails,
  buttonType = 'icon',
  customStyles = {},
}) => {
  const { dropdownRef, isDropdownOpen, setIsDropdownOpen } = useOutsideClick()

  const { roomStatus } = getGameRoomTimeDetails({
    entryOpenTime: grDetails?.startDate,
    entryCloseTime: grDetails?.endDate,
    gameStartTime: grDetails?.gameRoomActionStartDate,
    gameEndTime: grDetails?.gameRoomActionEndDate,
  })

  const shareUrl = `${window.location.origin}/game-rooms/${grDetails?.id}`

  return (
    <div className='GR-share-btn' ref={dropdownRef} style={customStyles}>
      {buttonType === 'icon' ? (
        <i
          className='bi bi-share-fill'
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        ></i>
      ) : (
        <button
          className='btn-action btn-share'
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          style={{ width: '100%' }}
        >
          <i className='bi bi-share'></i> Share
        </button>
      )}

      {isDropdownOpen && (
        <div
          className='dropdown'
          style={
            buttonType === 'button'
              ? {
                  right: '0',
                  top: '35px',
                  padding: '5px 20px',
                  height: '40px',
                  width: 'auto',
                  gap: '15px',
                }
              : undefined
          }
        >
          <button
            onClick={() => {
              shareTwitter(
                getShareMessage(
                  'twitter',
                  roomStatus,
                  grDetails?.name,
                  grDetails?.prizePool,
                  grDetails?.token
                ),
                shareUrl
              )
              setIsDropdownOpen(false)
            }}
          >
            <i className='bi bi-twitter-x'></i>
          </button>
          <button
            onClick={() => {
              shareTelegram(
                getShareMessage(
                  'telegram',
                  roomStatus,
                  grDetails?.name,
                  grDetails?.prizePool,
                  grDetails?.token
                ),
                shareUrl
              )
              setIsDropdownOpen(false)
            }}
          >
            <i className='bi bi-telegram'></i>
          </button>
          <button
            onClick={() => {
              shareWhatsApp(
                getShareMessage(
                  'whatsApp',
                  roomStatus,
                  grDetails?.name,
                  grDetails?.prizePool,
                  grDetails?.token
                ),
                shareUrl
              )
              setIsDropdownOpen(false)
            }}
          >
            <i className='bi bi-whatsapp'></i>
          </button>
        </div>
      )}
    </div>
  )
}

ShareActionDropdown.propTypes = {
  grDetails: PropTypes.object.isRequired,
  buttonType: PropTypes.oneOf(['icon', 'button']),
  customStyles: PropTypes.object,
}

export default ShareActionDropdown
